<template>
  <div>
    <el-cascader
        class="w-full"
        v-model="value"
        :options="issue.groups"
        :props="prop"
        :placeholder="issue.placeholder"
        clearable
        collapse-tags
        popper-class="linkage-popper"
        filterable
        @change="onChange"
    />
  </div>
</template>

<script>
import { questionType } from 'dygc'

export default {
  name: 'VoteCascadeSearch',
  type: [questionType.LINKAGE],
  props: {
    question: Object,
  },
  computed: {
    issue() {
      return this.question.issue
    }
  },
  data() {
    return {
      prop: {
        expandTrigger: 'hover',
        value: 'id',
        label: 'content',
        children: 'nextLevelOptions',
        multiple: true
      },
      value: []
    }
  },
  methods: {
    onChange() {
      this.issue.voteAnswer = this.value.map(ids => ids.slice().pop())
    }
  },
  mounted() {
    if (this.issue.voteAnswer) {
      const list = this.issue.toOneArray()
      const results = []
      list.forEach(item => {
        const lastId = item.id.split('/').pop()
        if (this.issue.voteAnswer.includes(lastId)) {
          results.push(item.id.split('/'))
        }
      })
      this.value = results
    }
  }
}
</script>

<style scoped>

</style>